<template>
    <v-app>
        <AppBar @clickIconBar="handleIconBar"/>
        <AppMenu
                v-model="activeMenu"
                :mini="miniMenu"
                class="elevation-3"
                clipped
        />
        <v-content>
            <transition name="fade" mode="out-in">
                <router-view />
            </transition>
        </v-content>
    </v-app>
</template>

<script>
    import AppBar from '@/components/AppBar.vue';
    import AppMenu from '@/components/AppMenu.vue';

    export default {
        components: {
            AppBar,
            AppMenu
        },
        created() {
        },
        data() {
            return {
                miniMenu: false,
                activeMenu: this.$vuetify.breakpoint.mdAndUp
            }
        },
        methods: {
            handleIconBar() {
                const mdAndUp = this.$vuetify.breakpoint.mdAndUp;

                if (mdAndUp) {
                    this.miniMenu = !this.miniMenu;
                } else {
                    this.miniMenu = false;
                    this.activeMenu = !this.activeMenu;
                }
            }
        }
    }
</script>